// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/list_generations_by_image.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/list_generations_by_image.proto.
 */
export const file_vision_generations_v1_list_generations_by_image: GenFile = /*@__PURE__*/
  fileDesc("CjV2aXNpb24vZ2VuZXJhdGlvbnMvdjEvbGlzdF9nZW5lcmF0aW9uc19ieV9pbWFnZS5wcm90bxIccHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MSLEAgodTGlzdEdlbmVyYXRpb25zQnlJbWFnZVJlcXVlc3QSUgoGcGFyYW1zGAEgASgLMkIucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5MaXN0R2VuZXJhdGlvbnNCeUltYWdlUmVxdWVzdC5QYXJhbXMSWgoKcGFnaW5hdGlvbhgCIAEoCzJGLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTGlzdEdlbmVyYXRpb25zQnlJbWFnZVJlcXVlc3QuUGFnaW5hdGlvbhouCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIQCghpbWFnZV9pZBgCIAEoCRpDCgpQYWdpbmF0aW9uEhEKCXBhZ2Vfc2l6ZRgBIAEoBRIUCgpuZXh0X3Rva2VuGAIgASgJSABCDAoKcGFnZV90b2tlbiLIAgoeTGlzdEdlbmVyYXRpb25zQnlJbWFnZVJlc3BvbnNlElMKBnJlc3VsdBgBIAEoCzJDLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTGlzdEdlbmVyYXRpb25zQnlJbWFnZVJlc3BvbnNlLlJlc3VsdBJbCgpwYWdpbmF0aW9uGAIgASgLMkcucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5MaXN0R2VuZXJhdGlvbnNCeUltYWdlUmVzcG9uc2UuUGFnaW5hdGlvbhpNCgZSZXN1bHQSQwoLZ2VuZXJhdGlvbnMYASADKAsyLi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLlZpc2lvbkdlbmVyYXRpb24aJQoKUGFnaW5hdGlvbhIXCg9uZXh0X3BhZ2VfdG9rZW4YASABKAliBnByb3RvMw", [file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.ListGenerationsByImageRequest
 */
export type ListGenerationsByImageRequest = Message<"protos.vision.generations.v1.ListGenerationsByImageRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ListGenerationsByImageRequest.Params params = 1;
   */
  params?: ListGenerationsByImageRequest_Params | undefined;

  /**
   * @generated from field: protos.vision.generations.v1.ListGenerationsByImageRequest.Pagination pagination = 2;
   */
  pagination?: ListGenerationsByImageRequest_Pagination | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ListGenerationsByImageRequest.
 * Use `create(ListGenerationsByImageRequestSchema)` to create a new message.
 */
export const ListGenerationsByImageRequestSchema: GenMessage<ListGenerationsByImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_generations_by_image, 0);

/**
 * @generated from message protos.vision.generations.v1.ListGenerationsByImageRequest.Params
 */
export type ListGenerationsByImageRequest_Params = Message<"protos.vision.generations.v1.ListGenerationsByImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ListGenerationsByImageRequest.Params.
 * Use `create(ListGenerationsByImageRequest_ParamsSchema)` to create a new message.
 */
export const ListGenerationsByImageRequest_ParamsSchema: GenMessage<ListGenerationsByImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_generations_by_image, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ListGenerationsByImageRequest.Pagination
 */
export type ListGenerationsByImageRequest_Pagination = Message<"protos.vision.generations.v1.ListGenerationsByImageRequest.Pagination"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from oneof protos.vision.generations.v1.ListGenerationsByImageRequest.Pagination.page_token
   */
  pageToken: {
    /**
     * @generated from field: string next_token = 2;
     */
    value: string;
    case: "nextToken";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.generations.v1.ListGenerationsByImageRequest.Pagination.
 * Use `create(ListGenerationsByImageRequest_PaginationSchema)` to create a new message.
 */
export const ListGenerationsByImageRequest_PaginationSchema: GenMessage<ListGenerationsByImageRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_generations_by_image, 0, 1);

/**
 * @generated from message protos.vision.generations.v1.ListGenerationsByImageResponse
 */
export type ListGenerationsByImageResponse = Message<"protos.vision.generations.v1.ListGenerationsByImageResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ListGenerationsByImageResponse.Result result = 1;
   */
  result?: ListGenerationsByImageResponse_Result | undefined;

  /**
   * @generated from field: protos.vision.generations.v1.ListGenerationsByImageResponse.Pagination pagination = 2;
   */
  pagination?: ListGenerationsByImageResponse_Pagination | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ListGenerationsByImageResponse.
 * Use `create(ListGenerationsByImageResponseSchema)` to create a new message.
 */
export const ListGenerationsByImageResponseSchema: GenMessage<ListGenerationsByImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_generations_by_image, 1);

/**
 * @generated from message protos.vision.generations.v1.ListGenerationsByImageResponse.Result
 */
export type ListGenerationsByImageResponse_Result = Message<"protos.vision.generations.v1.ListGenerationsByImageResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.VisionGeneration generations = 1;
   */
  generations: VisionGeneration[];
};

/**
 * Describes the message protos.vision.generations.v1.ListGenerationsByImageResponse.Result.
 * Use `create(ListGenerationsByImageResponse_ResultSchema)` to create a new message.
 */
export const ListGenerationsByImageResponse_ResultSchema: GenMessage<ListGenerationsByImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_generations_by_image, 1, 0);

/**
 * @generated from message protos.vision.generations.v1.ListGenerationsByImageResponse.Pagination
 */
export type ListGenerationsByImageResponse_Pagination = Message<"protos.vision.generations.v1.ListGenerationsByImageResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.vision.generations.v1.ListGenerationsByImageResponse.Pagination.
 * Use `create(ListGenerationsByImageResponse_PaginationSchema)` to create a new message.
 */
export const ListGenerationsByImageResponse_PaginationSchema: GenMessage<ListGenerationsByImageResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_generations_by_image, 1, 1);

